import React from 'react'
import PropTypes from 'prop-types'
import emptyPng from 'App/../public/images/empty.png' // TODO: Fix these paths
import colorPng from 'App/../public/images/open-in-new-window.png'
import whitePng from 'App/../public/images/open-in-new-window-white.png'
import { css } from '@emotion/core'

const imageStyle = css`
  margin-left: 8px;
  align-self: center;
`

const TargetBlankIcon = ({ empty, reversed, size }) => (
  <img
    src={empty ? emptyPng : reversed ? whitePng : colorPng}
    alt={__('opens in new window')}
    css={css`
      width: ${empty ? 0 : size}px;
      ${!empty && imageStyle}
    `}
  />
)

TargetBlankIcon.propTypes = {
  empty: PropTypes.bool,
  reversed: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

TargetBlankIcon.defaultProps = {
  size: 10,
}

export default TargetBlankIcon
